module.exports = __webpack_public_path__ + "img/BANNER-REVISTA-TRAEESA-DESKTOP.d2e30829.jpg";